<template>
    <div
        class="grid items-center gap-4 px-4 py-6 mx-auto max-w-sm rounded-lg border border-gray-200 bg-gray-50 dark:border-gray-800 dark:bg-gray-900">
        <p class="text-sm">
            We need your email address to verify your identity when submitting a
            request to delete your CarryGo account. We will reach out to you
            at this email address to confirm your request. When your account is
            deleted, all information associated with your account will be deleted
            including the following:
            <br />
            <br />
            1. Your email address
            <br />
            2. Your name, if you added one
            <br />
            3. Your profile picture, if you added one
        </p>
        <form class="space-y-4" @submit.prevent="handleSubmit">
            <div class=" mt-2">
                <label for="Email Address">Email Address</label><br>
                <input class="border outline-none mt-1 w-full p-1 rounded-lg border-blue-800" type="text" name="email"
                    id="email" v-model="email">
                <p class=" text-sm text-red-600" v-if="emailValidity === 'invalid'">this field cannot be empty</p>
            </div>
            <div class=" mt-2 flex">
                <button class=" w-1/2 m-auto bg-blue-800 p-2 text-white  rounded-lg  ">Send Message </button>
                <p v-if="isLoading"
                    class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 ">
                </p>
            </div>
        </form>
        <div v-if="successMessage" class="mt-2 text-green-500 text-sm text-center">
            {{ successMessage }}
        </div>
        <div v-if="errorMessage" class="mt-2 text-red-500 text-sm text-center">
            {{ errorMessage }}
        </div>
        <SuccessfulModal v-show="isModalVisible" @click="close" :message="message" />
    </div>
</template>

<script>
import { baseUrl } from '../../Config';
const url = baseUrl;
import axios from 'axios';
import SuccessfulModal from './SuccessfulModal.vue'
export default {
    name: "AccountDeletionForm",
    components: {
        SuccessfulModal
    },
    data() {
        return {
            email: "",
            emailValidity: '',
            errorMessage: '',
            isLoading: false,
            isModalVisible: false,
            message: ""
        }
    },
    methods: {
        close() {
            this.isModalVisible = false
        },
        handleSubmit() {
            if (!this.email) {
                this.emailValidity = 'invalid';
                setTimeout(() => {
                    this.emailValidity = '';
                }, 3000);
            } else {
                this.isLoading = true;
                axios({
                    method: "POST",
                    url: `${url}/v1/web/extras/feedback`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key': '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        name: "Account Deletion Request",
                        email: this.email,
                        subject: "Account Deletion Request",
                        message: `${this.email} wants to delete their account.`
                    }
                })
                    .then((response) => {
                        this.isLoading = false;
                        console.log(response);
                        this.isModalVisible = true;
                        this.message = "Your request has been submitted. Please check your inbox for confirmation.";
                        this.email = '';
                    })
                    .catch((error) => {
                        console.log(error);
                        this.errorMessage = error.response.data.message;
                        setTimeout(() => {
                            this.errorMessage = '';
                        }, 3000);
                        this.isLoading = false;
                    })
            }
        }
    }
}
</script>